import { PROJECT_INFO } from 'redux/types/projectInfo.types';

let PROJECT_INFO_RES = {
    projectInfo: '',
};

const projectInfoReducer = (state = PROJECT_INFO_RES, action) => {
    switch (action.type) {
        case PROJECT_INFO:
            return {
                ...state, projectInfo: action.payload,
            };
        default: return state;
    }
};

export default projectInfoReducer;